import { supabase } from "@/integrations/supabase/client";

const SHOP_KEY = "pending_shopify_shop";
const SHOP_EMAIL_KEY = "pending_shopify_email";
const SHOP_NAME_KEY = "pending_shopify_name";
const SHOP_CURRENCY_KEY = "pending_shopify_currency";
const SESSION_KEY = "pending_shopify_session";

export interface PendingShopifyContext {
  sessionToken: string | null;
  shop: string | null;
  shopEmail: string | null;
  shopName: string | null;
  shopCurrency: string | null;
}

export function getPendingShopifyContext(): PendingShopifyContext {
  if (typeof window === "undefined") {
    return {
      sessionToken: null,
      shop: null,
      shopEmail: null,
      shopName: null,
      shopCurrency: null,
    };
  }

  return {
    sessionToken: sessionStorage.getItem(SESSION_KEY),
    shop: sessionStorage.getItem(SHOP_KEY),
    shopEmail: sessionStorage.getItem(SHOP_EMAIL_KEY),
    shopName: sessionStorage.getItem(SHOP_NAME_KEY),
    shopCurrency: sessionStorage.getItem(SHOP_CURRENCY_KEY),
  };
}

export function setPendingShopifyContext(context: {
  sessionToken?: string | null;
  shop?: string | null;
  shopEmail?: string | null;
  shopName?: string | null;
  shopCurrency?: string | null;
}): void {
  if (typeof window === "undefined") {
    return;
  }

  persistSessionValue(SESSION_KEY, context.sessionToken);
  persistSessionValue(SHOP_KEY, context.shop);
  persistSessionValue(SHOP_EMAIL_KEY, context.shopEmail);
  persistSessionValue(SHOP_NAME_KEY, context.shopName);
  persistSessionValue(SHOP_CURRENCY_KEY, context.shopCurrency);
}

export function clearPendingShopifyContext(): void {
  if (typeof window === "undefined") {
    return;
  }

  sessionStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem(SHOP_KEY);
  sessionStorage.removeItem(SHOP_EMAIL_KEY);
  sessionStorage.removeItem(SHOP_NAME_KEY);
  sessionStorage.removeItem(SHOP_CURRENCY_KEY);
}

export async function finalizePendingShopifyInstall(sessionToken?: string | null) {
  const pendingContext = getPendingShopifyContext();
  const tokenToUse = sessionToken || pendingContext.sessionToken;
  if (!tokenToUse) {
    return null;
  }

  const { data, error } = await supabase.functions.invoke("finalize-shopify-install", {
    body: {
      sessionToken: tokenToUse,
      shopCurrency: pendingContext.shopCurrency,
    },
  });

  if (error) {
    throw error;
  }

  clearPendingShopifyContext();
  if (typeof window !== "undefined" && data?.merchantId) {
    localStorage.setItem("active_merchant_id", String(data.merchantId));
  }
  return data;
}

function persistSessionValue(key: string, value?: string | null) {
  if (!value) {
    sessionStorage.removeItem(key);
    return;
  }

  sessionStorage.setItem(key, value);
}
